<template>
  <div class="purchase-container">
    <el-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="Purchase"
      top="5vh"
      :before-close="handleClose"
    >
      <div v-if="!token">
        <el-form
          :model="purchaseForm"
          id="purchaseForm"
          ref="purchaseForm"
          label-width="250px"
          size="small"
          :rules="purchaseFormRules"
          :label-position="device === 'mobile' ? 'top' : 'right'"
        >
          <el-form-item label="Action" prop="action">
            <el-select v-model="purchaseForm.action">
              <el-option label="Debit" value="debit"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="Amount" prop="amount">
            <el-input
              type="number"
              v-model="purchaseForm.amount"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="Beneficiary Name" prop="beneficiaryName">
            <el-input
              v-model="purchaseForm.beneficiaryName"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="Beneficiary bank name"
            prop="beneficiaryBankName"
          >
            <el-input
              v-model="purchaseForm.beneficiaryBankName"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="Beneficiary Account number"
            prop="beneficiaryAccountnumber"
          >
            <el-input
              v-model="purchaseForm.beneficiaryAccountnumber"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="Beneficiary BIC" prop="beneficiaryBic">
            <el-input
              v-model="purchaseForm.beneficiaryBic"
              autocomplete="off"
            ></el-input>
          </el-form-item>

          <el-form-item>
            <el-button
              :loading="submitingPurchase"
              type="primary"
              @click="submitPurchase()"
              >Submit</el-button
            >
            <el-button @click="dialogVisible = false">Cancel</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div v-else>
        <div style="margin: 15px;">
          <el-input :readonly="true" v-model="token">
            <template slot="prepend"
              >Receipt Key</template
            >
          </el-input>
        </div>
        <div style="margin: 15px; text-align: center;">
          <el-button :icon="btnIcon" :type="btnType" @click="copyText()">{{
            btnText
          }}</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { bankPurchase } from "@/api/bank-account";
export default {
  computed: {
    device() {
      return this.$store.state.app.device;
    },
    superRole() {
      return this.roleAuth([this.role.spadmin]);
    },
  },
  data() {
    return {
      dialogVisible: false,
      submitingPurchase: false,
      currency: "",
      btnText: "Click Copy",
      btnType: "primary",
      btnIcon: "el-icon-copy-document",
      bankholderID: "",
      purchaseForm: {
        action: "debit",
        amount: 0,
        beneficiaryName: "",
        beneficiaryBankName: "",
        beneficiaryAccountnumber: "",
        beneficiaryBic: "",
      },
      token: "",
      purchaseFormRules: {
        amount: [
          {
            required: true,
            message: "Please enter Amount",
            trigger: "blur",
          },
          {
            min: 1,
            message: "Please enter Amount",
            trigger: "blur",
          },
        ],
        beneficiaryName: [
          {
            required: true,
            message: "Please enter beneficiary name",
            trigger: "blur",
          },
        ],
        beneficiaryBankName: [
          {
            required: true,
            message: "Please enter beneficiary bank name",
            trigger: "blur",
          },
        ],
        beneficiaryAccountnumber: [
          {
            required: true,
            message: "Please enter beneficiary account number",
            trigger: "blur",
          },
        ],
        beneficiaryBic: [
          {
            required: true,
            message: "Please enter beneficiary BIC",
            trigger: "blur",
          },
        ],
        
      },
    };
  },
  methods: {
    show(bankholderID = "0000001", currency) {
      this.submitingPurchase = false;
      this.dialogVisible = true;
      this.bankholderID = bankholderID;
      this.currency = currency;
      this.token = "";
      this.purchaseForm.action = "debit";
      this.purchaseForm.amount = 0;
      this.purchaseForm.beneficiaryName = "";
      this.purchaseForm.beneficiaryBankName = "";
      this.purchaseForm.beneficiaryAccountnumber = "";
      this.purchaseForm.beneficiaryBic = "";
      
      this.copyBtn();
    },

    copyBtn() {
      this.btnText = "Click Copy";
      this.btnType = "primary";
      this.btnIcon = "el-icon-copy-document";
    },
    copiedBtn() {
      this.btnText = "Copied";
      this.btnType = "success";
      this.btnIcon = "el-icon-check";
    },

    submitPurchase() {
      
      this.$refs.purchaseForm.validate((valid) => {
        if (valid) {
          this.submitingPurchase = true;
          bankPurchase(this.bankholderID, this.purchaseForm).then(
            ({ result, data }) => {
              this.submitingPurchase = false;
              if (result) {
                this.token = data.receiptToken;
              } else {
              }
            }
          );
        }
      });
    },
    copyText() {
      var cpText = this.token;
      const el = document.createElement("textarea");
      el.value = cpText;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      const selected =
        document.getSelection().rangeCount > 0
          ? document.getSelection().getRangeAt(0)
          : false;
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
      this.copiedBtn();
      setTimeout(() => {
        this.copyBtn();
      }, 3000);
    },
    handleClose(done) {
      if (this.token) {
        this.$emit("submited");
      }

      done();
    },
  },
};
</script>

<style lang="scss">
.purchase-container {
  .el-dialog__body {
    padding: 10px;
  }
  .el-tab-pane {
    padding: 20px;
  }
}
</style>
